import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "../data/site";

const btn = "group flex h-12 items-center gap-0 overflow-hidden rounded-full pl-3.5 pr-3.5 shadow-[0_12px_30px_-10px_rgba(0,0,0,.45)] transition-[gap,padding,background-color] duration-500 hover:gap-2 hover:pr-5";
const label = "max-w-0 whitespace-nowrap text-sm font-semibold opacity-0 transition-[max-width,opacity] duration-500 group-hover:max-w-[140px] group-hover:opacity-100 group-focus-visible:max-w-[140px] group-focus-visible:opacity-100";

export const FloatingActions = () => (
  <div className="fixed bottom-4 right-4 z-[55] flex flex-col items-end gap-2 sm:bottom-6 sm:right-6" data-testid="floating-actions">
    <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Scrivici su WhatsApp" data-testid="floating-whatsapp" className={`${btn} bg-[#25D366] text-[#0b2e17]`}>
      <MessageCircle size={20} strokeWidth={1.8} aria-hidden="true" /><span className={label}>WhatsApp</span>
    </a>
    <a href={CONTACT.phoneMobileHref} aria-label="Chiama ora" data-testid="floating-call" className={`${btn} bg-[color:var(--ngp-ink)] text-white ring-1 ring-white/25`}>
      <Phone size={19} strokeWidth={1.8} aria-hidden="true" /><span className={label}>Chiama ora</span>
    </a>
  </div>
);
